import styles from "./index.module.scss";

export default function ThemeSwitch({ checked, onChange }: { checked: boolean; onChange: () => void }) {
  return (
    <label className={styles.switch}>
      <input type="checkbox" aria-label="Темная тема" checked={checked} onChange={onChange} />
      <span className={styles.track} aria-hidden="true" />
      <span className={styles.thumb} aria-hidden="true">
        <svg viewBox="0 0 20 20" width="20" height="20" fill="white">
          {checked ? <path d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z" /> : <><circle cx="10" cy="10" r="4" /><path stroke="white" strokeWidth="1.4" d="M10 1v2M10 17v2M1 10h2M17 10h2M3.6 3.6 5 5M15 15l1.4 1.4M3.6 16.4 5 15M15 5l1.4-1.4" /></>}
        </svg>
      </span>
    </label>
  );
}
